import { FormEvent, useState } from "react";
import { logger } from "../../observability/LoggerFactory";
import { useLogin, useNotify, useAuthState } from "react-admin";
import { Navigate } from "react-router-dom";
import { Box, Button, Card, CardContent, TextField, Typography } from "@mui/material";
import type { JSX } from "react";

export function Login() {
  let loginOutcome: JSX.Element | null;
  const login = useLogin();
  const notify = useNotify();
  const { isPending, authenticated } = useAuthState();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const handleSubmit = (event: FormEvent) => {
    event.preventDefault();
    setSubmitting(true);
    void (async () => {
      try {
        await login({ username, password });
      } catch (error: unknown) {
        logger.error({ err: error, component: "Login" }, "Login attempt failed");
        notify("Неверный логин или пароль", { type: "error" });
      } finally {
        setSubmitting(false);
      }
    })();
  };
  if (isPending) {
    loginOutcome = null;
  } else {
    if (authenticated) {
      loginOutcome = <Navigate to="/" replace />;
    } else {
      loginOutcome = (
    <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
      <Card sx={{ minWidth: 340 }}>
        <CardContent>
          <Typography variant="h5" gutterBottom>
            Вход
          </Typography>
          <form onSubmit={handleSubmit}>
            <TextField
              label="Логин"
              value={username}
              onChange={(event) => setUsername(event.target.value)}
              fullWidth
              margin="normal"
              autoFocus
            />
            <TextField
              label="Пароль"
              type="password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              fullWidth
              margin="normal"
            />
            <Button type="submit" variant="contained" fullWidth disabled={submitting} sx={{ mt: 2 }}>
              {submitting ? "Вход…" : "Войти"}
            </Button>
          </form>
        </CardContent>
      </Card>
    </Box>
  );
    }
  }
  return loginOutcome;
}
